import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
//Import components
import Header from './common/Header'
import Sidebar from './common/Sidebar'
import Footer from './common/Footer'
import Home from './Home'
import Profile from './Profile'

import Jobs from './job/Jobs'
import CreateJob from './job/CreateJob'
import EditJob from './job/EditJob'
import CopyJob from './job/CopyJob'
import EditCopyJob from './job/EditCopyJob'

import JobApplys from './jobapply/JobApplys'
import EditJobApply from './jobapply/EditJobApply'

import Messages from './messages/Message'

import _404 from './static/_404'
import _500 from './static/_500'
import _503 from './static/_503'

const DefaultLayout = ({component: Component, ...rest}) => {
    return (
        <Route {...rest} render={matchProps => (
            <React.Fragment>
                <div className="wrapper">
                    <Sidebar />
                    <div id="content">
                        <Header />
                        <Component {...matchProps} />
                    </div>
                    <Footer />
                </div>
            </React.Fragment>
        )} />
    )
}

const StaticLayout = ({component: Component, ...rest}) => {
    return (
        <Route {...rest} render={matchProps => (
            <Component {...matchProps} />
        )} />
    )
}

const HoujinMain = () => (
    <BrowserRouter>
        <Switch>
            <DefaultLayout exact path='/houjin/home' component={Home} />
            <DefaultLayout exact path='/houjin/profile' component={Profile} />

            <DefaultLayout exact path='/houjin/jobs' component={Jobs} />
            <DefaultLayout exact path='/houjin/jobs/create' component={CreateJob} />
            <DefaultLayout exact path='/houjin/jobs/edit/:id' component={EditJob} />
            <DefaultLayout exact path='/houjin/jobs/copy' component={CopyJob} />
            <DefaultLayout exact path='/houjin/jobs/copy/edit' component={EditCopyJob} />

            <DefaultLayout exact path='/houjin/jobapplys' component={JobApplys} />
            <DefaultLayout exact path='/houjin/jobapplys/edit/:id' component={EditJobApply} />

            <DefaultLayout exact path='/houjin/messages' component={Messages} />

            <StaticLayout exact path='/_404' component={_404} />
            <StaticLayout exact path='/_500' component={_500} />
            <StaticLayout exact path='/_503' component={_503} />

            <StaticLayout component={_404} />
        </Switch>
    </BrowserRouter>
);

export default HoujinMain;
